import React, { useState } from "react"
import { Button, Card, CardBody, Collapse } from "reactstrap"
import CustomHeaderTitle from "components/Common/CustomHeaderTitle"
import GeneralTables from "components/Common/GeneralTable"
import ActionColumns from "components/Common/GeneralTable/ActionColumns"
import CSAlert from "components/Alert/ConfirmationAlert"
import { isEmpty, result } from "lodash"
import SAlert from "components/Alert"
import ProviderOutFilter from "./ProviderOutFilter"
import ProviderOutTotalBox from "./ProviderOutTotalBox"
import { downloadURL } from "api/APP_URL"
import CurrencyComponent from "components/Common/CurrencyComponent"

const ProviderOutListComponent = ({
  data,
  error,
  loading,
  onPageClick,
  onSearch,
  onChangeRowNumber,
  onChangeOrdering,
  onClickDelete,
  onAllDeleteClicked,
  onAdvancedSearchSubmit,
  permissions,
  onClickDetail,
  exportStatus,
  onExportBtnClick,
}) => {
  const [ids, setIds] = useState([])
  const [filterOpen, setFilterOpen] = useState(false)

  // Store record in thier Dispatch when a checkbox is clicked
  const onCheckboxClick = (e, id) => {
    const check = ids.includes(id)
    if (check) {
      const updated = ids.filter(myId => myId !== id)
      setIds(updated)
    } else {
      setIds(prev => {
        return [...prev, id]
      })
    }
  }

  // Handle bulk deletion when top delete button is clicked and confirmed
  const onAllDeleteHandler = async () => {
    const results = await CSAlert({
      title: "Are you sure delete?",
    })
    if (results.isConfirmed) {
      onAllDeleteClicked(ids)
    }
  }

  // Handle parent checkbox status change to select/deselect all items
  const onParentCheckChange = status => {
    if (status) {
      const all = data?.data.map(dt => dt.id)
      setIds(all)
    } else {
      setIds([])
    }
  }

  // Callback function to toggle the advanced search filter visibility when the button is clicked
  const onAdvancedSearchHandler = result => {
    setFilterOpen(result)
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          {/*
            CustomHeaderTitle Component Props:
            
            - loading: Boolean flag to display loading state
            - title: String to display as the header title
            - rowCount: Boolean to show/hide the row number selector
            - lgColumn: Number to control the width of columns based on layout needs
            - onChangeRowNumber: Callback function to handle row number selection change
            - orderingList: Boolean to show/hide ordering dropdown
            - onChangeOrdering: Callback function triggered when the ordering option is changed
            - searchBox: Boolean to show/hide search input box
            - onSearchHandler: Function called on key up in the search box
            - rightBtn: Boolean to show/hide right-side button (for example, a back button)
            - rightBtnTitle: String for setting the right button's label
            - rightBtnRoute: Route for the right button's navigation
            - exportBtn: Boolean to show/hide export button
            - onExportBtnClick: Callback for when the export button is clicked
            - exportBtnLoading: Boolean flag to show loading state during export functionality
            - advnacedSearchBtn: Boolean to show/hide advanced search button
            - advnacedSearchBtnTitle: String to display the advanced search button label
            - onAdvancedSearch: Callback function when the advanced search button is clicked (used to toggle collapse)
            - orderingOptions: Array of options to populate the ordering dropdown (value and name pair)
          */}
          <CustomHeaderTitle
            loading={loading}
            title={"List"}
            rowCount={true}
            onChangeRowNumber={onChangeRowNumber}
            orderingList={true}
            onChangeOrdering={onChangeOrdering}
            searchBox={true}
            onSearchHandler={onSearch}
            rightBtn={true}
            rightBtnTitle={"Add Distribution"}
            rightBtnRoute={"/add-provider-distributions"}
            deleteBtn={permissions.includes("delete-provider-in")}
            onAllDeleteHandler={onAllDeleteHandler}
            advnacedSearchBtn={true}
            advnacedSearchBtnTitle={"Filter"}
            onAdvancedSearch={onAdvancedSearchHandler}
            exportBtn={true}
            exportBtnLoading={exportStatus?.loading}
            onExportBtnClick={onExportBtnClick}
            orderingOptions={[
              { value: "id", name: "ID" },
              { value: "ip_id", name: "IP" },
              { value: "province_id", name: "Province" },
              { value: "date", name: "Submission Date" },
            ]}
          />
          <ProviderOutTotalBox totals={data?.totals} />
          <Collapse isOpen={filterOpen}>
            {/* Provider Distributin Filter  */}
            <ProviderOutFilter
              loading={loading}
              onAdvancedSearchSubmit={onAdvancedSearchSubmit}
            />
          </Collapse>

          {/*
            GeneralTables Component Props:

            - data: Array containing the data to be displayed in the table
            - loading: Boolean indicating the loading state of the table
            - parentCheckbox: Boolean to determine if a parent checkbox is included in the table
            - headers: Array of strings representing the column headers for the table
            - pagination: Object containing pagination metadata and a callback function:
                - meta: Object for pagination details (e.g., page number, total items)
                - onPageClick: Callback function to handle page number changes
            - renderItem: Function to render each row/item in the table using the provided data
          */}
          <GeneralTables
            data={data?.data}
            loading={loading}
            onParentCheckChange={onParentCheckChange}
            headers={[
              "SN",
              "DS NUMBER",
              "PROJECT",
              "PROVIDER",

              "IP",
              "TRANSACTION TYPE",
              "DISTRIBUTOR",
              "WAREHOUSE DISTRIBUTE",
              "PROVINCE",
              "FACILITY",
              "UNFPA ITEM ID",
              "IP- ITEM DESCRIPTION",
              "UNFPA UNIT OF MEASURE (UOM))",
              "IP UNIT UOM",
              "UNIT PRICE (AS PER UNFPA)",
              "UNIT PRICE (AS PER IP UOM)",
              "BATCH NUMBER",
              "EXPIRE DATE",
              "DISTRIBUTED QTY PER IP\t",
              "DISTRIBUTION DATE",

              "Action",
            ]}
            pagination={{ meta: data?.meta, onPageClick: onPageClick }}
            renderItem={(pOut, index) => {
              const transactionType = !isEmpty(pOut?.transaction_type)
                ? pOut?.transaction_type
                : "Distribution"
              return (
                <tr key={index}>
                  <th scope="row">
                    {" "}
                    <div className="form-check form-checkbox-outline form-check-primary mb-3">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`checkbox-${pOut.id}`}
                        checked={ids.includes(pOut.id)}
                        onChange={e => onCheckboxClick(e, pOut.id)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`checkbox-${pOut.id}`}
                      >
                        {data?.meta?.from + index}
                      </label>
                    </div>
                  </th>
                  <td>{pOut?.provider_in?.receipt_number || "-"}</td>
                  <td>{pOut?.project?.name}</td>
                  <td>{pOut?.provider?.title}</td>
                  <td>{pOut?.ip?.name}</td>
                  <td>{transactionType}</td>
                  <td>{pOut?.distributor}</td>
                  <td>{pOut?.warehouse_disribute}</td>
                  <td>{pOut?.province?.province}</td>

                  <td>
                    {pOut?.facility?.facility_name &&
                    pOut?.facility?.facility_name != "Others"
                      ? pOut?.facility?.facility_name
                      : pOut?.other_hfs
                      ? `Others ( ${pOut?.other_hfs} )`
                      : ""}
                  </td>
                  <td>{pOut?.item?.unfp_item_name}</td>
                  <td>{pOut?.item?.ip_item_description}</td>
                  <td>
                    {pOut?.item.uom} &nbsp;
                    {pOut?.item.unfpa_uom_quantity > 1 &&
                      pOut?.item.unfpa_uom_quantity}
                  </td>
                  <td>
                    {pOut?.item.ip_unit_umo} &nbsp;
                    {pOut?.item.ip_uom_quantity > 1 &&
                      pOut?.item.ip_uom_quantity}
                  </td>
                  <td>
                    <CurrencyComponent
                      currency={pOut?.provider_in?.currency}
                      amount={pOut?.provider_in?.unit_price_per_unfpa}
                    />
                  </td>
                  <td>
                    <CurrencyComponent
                      currency={pOut?.provider_in?.currency}
                      amount={pOut?.provider_in?.unit_price_per_ip}
                    />
                  </td>
                  <td>{pOut?.provider_in?.batch_number}</td>
                  <td>{pOut?.provider_in?.expire_date}</td>
                  <td>{pOut?.out_quantity}</td>
                  <td>{pOut?.date}</td>
                  <td>
                    {/* Render action columns with Edit and Delete options for each project  */}
                    {pOut.deleteStatus === 0 ? (
                      <ActionColumns
                        data={pOut}
                        enableEdit={
                          permissions.includes("update-provider-in") &&
                          !pOut.locked
                        }
                        enableDelete={
                          permissions.includes("delete-provider-in") &&
                          !pOut.locked
                        }
                        enableDetail={true}
                        editRoute={`/edit-provider-distributions/${pOut.id}`}
                        onClickDetail={onClickDetail}
                        onClickDelete={onClickDelete}
                        enableDocumentLink={pOut?.document}
                        documentLink={`${downloadURL}/${pOut?.document}`}
                        disabled={pOut.locked}
                        disabledMessage="Locked due to pending transfer"
                      />
                    ) : (
                      <Button className="btn btn-info btn-sm">Pending</Button>
                    )}
                  </td>
                </tr>
              )
            }}
          />
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default ProviderOutListComponent
